import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import ZonesPage from "@/pages/zones/page";
import ZoneDetail from "@/pages/zone/page";
import PostDetail from "@/pages/post/page";
import RankingPage from "@/pages/ranking/page";
import AboutPage from "@/pages/about/page";
import FaqPage from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "zones",
        element: <ZonesPage />,
      },
      {
        path: "zone/:id",
        element: <ZoneDetail />,
      },
      {
        path: "post/:id",
        element: <PostDetail />,
      },
      {
        path: "ranking",
        element: <RankingPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "faq",
        element: <FaqPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;